module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_rectangular_marco_comida_55.c2e6c1c2.png";